import { GetCustomerApplicationsRoutine } from '../redux-routines';

export const initialState = {
  isFetching: false,
  data: [],
  error: null
};

export const customerApplicationsReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case GetCustomerApplicationsRoutine.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload,
        error: null
      };
    case GetCustomerApplicationsRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
        data: [],
        error: null
      };
    case GetCustomerApplicationsRoutine.FAILURE:
      return {
        ...state,
        isFetching: false,
        data: [],
        error: action.payload
      };

    default:
      return state;
  }
};
